export default __webpack_public_path__ + "static/media/new_user_activity_37.56b3f4af.png";